var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-684 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(684 252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.945-.6h0A3.859,3.859,0,0,1,12.539.629,3.652,3.652,0,0,1,13.923,3.5,3.937,3.937,0,0,1,12.688,5.9L5.85,13.133a2.994,2.994,0,0,1-1.492.807L1.67,14.4a2.315,2.315,0,0,1-.392.034,1.852,1.852,0,0,1-1.4-.6,1.978,1.978,0,0,1-.459-1.564l.309-2.7V9.553A3.122,3.122,0,0,1,.44,8.03L7.283.787A3.7,3.7,0,0,1,9.945-.6ZM1.279,13.233a1.115,1.115,0,0,0,.189-.017l2.684-.458a1.838,1.838,0,0,0,.816-.438l.007-.008,6.842-7.242a2.83,2.83,0,0,0,.909-1.654A2.514,2.514,0,0,0,11.715,1.5,2.737,2.737,0,0,0,9.945.6h0a2.574,2.574,0,0,0-1.79,1.012L1.314,8.853a1.986,1.986,0,0,0-.4.854L.607,12.4a.8.8,0,0,0,.161.629A.661.661,0,0,0,1.279,13.233Z",
    transform: "translate(3.331 1.801)",
    fill: "#9facc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.542,4.892a.607.607,0,0,1-.061,0A5.711,5.711,0,0,1-.593.092a.6.6,0,0,1,.5-.685.6.6,0,0,1,.685.5A4.511,4.511,0,0,0,4.6,3.695a.6.6,0,0,1-.059,1.2Z",
    transform: "translate(9.908 4.208)",
    fill: "#9facc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,.6H0A.6.6,0,0,1-.6,0,.6.6,0,0,1,0-.6H15a.6.6,0,0,1,.6.6A.6.6,0,0,1,15,.6Z",
    transform: "translate(2.5 18.333)",
    fill: "#9facc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H20V20H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProject);
export default __webpack_public_path__ + "static/media/edit_project.cae2301c40dcc129a24cdf6900a3cf91.svg";
export { ForwardRef as ReactComponent };